import { SparkArray } from '@core/valueTypes/spark-array.valueTypes';

export const ACTIVATED_STATUS = 'Activated';

export interface IUserContract {
  id: string;
  firstName: string;
  lastName: string;
  portfolioId: string;
  roleName?: string;
  activationStatus?: string | null;
}

export class User {
  id: string;
  firstName: string;
  lastName: string;
  portfolioId: string;
  roleName: string;
  activationStatus: string | null = null;

  constructor(user: IUserContract) {
    this.id = user.id;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.portfolioId = user.portfolioId || '';
    this.roleName = user.roleName || '';
    this.activationStatus = user.activationStatus ?? null;
  }

  get displayName() {
    return `${this.firstName} ${this.lastName}`;
  }

  get isActive(): boolean {
    // Treat a missing status as active so lists that don't request activation
    // status (all the active-only assign flows) are unaffected.
    return this.activationStatus === null || this.activationStatus === ACTIVATED_STATUS;
  }
}

export class UserList extends SparkArray<User> {
  constructor(users: IUserContract[] = []) {
    super(users.map((u) => new User(u)));
  }
  getByPortfolioId(portfolioId: string) {
    return this.find((u) => u.portfolioId === portfolioId);
  }

  getByUserId(userId: string) {
    return this.find((u) => u.id === userId);
  }
}

export function findUserByPortfolioId(
  users: User[],
  portfolioId: string
): User | undefined {
  return users.find((u) => u.portfolioId == portfolioId);
}
